import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_META__field_info } from '../_fields/_base/DTO_META__field_info';
import { FIELD__base } from '../_fields/_base/FIELD__base';
import { ERROR_GRAPH__base } from './ERROR_GRAPH__base';

export class ERROR_GRAPH__field extends ERROR_GRAPH__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.ERROR_GRAPH_FIELD;

  /*
   * STATIC METHODS
   */
  static create(type: ENUM__error_type, field: FIELD__base = FIELD__base.CREATE_STUB()) {
    let out = new ERROR_GRAPH__field();

    out.type = type;
    out.meta = field.meta.clone();

    return out;
  }

  /*
   * FIELDS
   */
  meta: DTO_META__field_info;

  /*
   * METHODS
   */

  constructor() {
    super();
    this.meta = DTO_META__field_info.CREATE_STUB();
  }

  toString(): string {
    return `${this.meta.node_type}.${this.meta.field_path}:${this.type}`;
  }

  override is_equals(other: ERROR_GRAPH__base): boolean {
    if (!super.is_equals(other)) return false;
    if (!(other instanceof ERROR_GRAPH__field)) return false;

    return other.meta.field_id == this.meta.field_id;
  }
}
